import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDropzone, Accept } from 'react-dropzone';
import { useEditorContext } from '../../Editor/Context';
import s from './EditorDropzone.scss';

export interface Props {
  label?: string;
  className?: string;
  classNameAccept?: string;
  classNameReject?: string;

  acceptedFileTypes?: Accept;
}

const defaultAcceptedFileTypes = {
  'image/*': [],
};

const EditorDropzone: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  classNameAccept,
  classNameReject,
  acceptedFileTypes: accept = defaultAcceptedFileTypes,
}) => {
  const editor = useEditorContext();
  const onDrop = useCallback(
    acceptedFiles => {
      if (acceptedFiles.length) {
        editor?.commands?.daUploadFile(acceptedFiles[0]);
      }
    },
    [editor?.commands]
  );

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop,
    accept,
    noClick: true,
  });

  return (
    <div
      {...getRootProps()}
      className={classnames(
        className,
        isDragAccept && s['accept-drop'],
        isDragAccept && classNameAccept,
        isDragReject && s['reject-drop'],
        isDragReject && classNameReject
      )}
      data-wrapper="1"
    >
      {isDragActive && <input {...getInputProps()} />}
      {children}
    </div>
  );
};
EditorDropzone.displayName = 'EditorDropzone';

export default EditorDropzone;
